import {languagesConstants} from "../../constants/Public/allLanguages.constans";

const initialState = {
    fetching : false,
    status : false,
    languages : [],
    error : '',
};

export default function (state = initialState, action) {
    switch (action.type) {
        case languagesConstants.ALL_LANGUAGES_PENDING:
            return {
                ...state,
                fetching: true,
                status: false,
            };
        case languagesConstants.ALL_LANGUAGES_FULFILLED:
            return {
                ...state,
                fetching: false,
                status: true,
                languages: action.payload,
            };
        case languagesConstants.ALL_LANGUAGES_REJECTED:
            return {
                ...state,
                error: action.payload,
                fetching: false
            };
        case "CLEAR_STATE" :
            return {
                ...initialState
            }
        default:
            return state
    }
}
